import { render, staticRenderFns } from "./DeepSeekApp.vue?vue&type=template&id=133119cc&scoped=true"
import script from "./DeepSeekApp.vue?vue&type=script&lang=js"
export * from "./DeepSeekApp.vue?vue&type=script&lang=js"
import style0 from "./DeepSeekApp.vue?vue&type=style&index=0&id=133119cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133119cc",
  null
  
)

export default component.exports